<template>
  <div v-if="followUpQuestions.length > 0">
    <div class="text-caption primary-grey--text text--lighten-1 font-weight-regular mb-2">
      Want to explore more? Choose your next question or type your own below:
    </div>
    <div class="d-flex flex-wrap ma-1">
      <v-chip
        v-for="(question, index) in followUpQuestions"
        :key="index"
        outlined
        :color="COLORS.grainfoxAIButton"
        class="ma-1 text-caption follow-up-chip"
        :class="{ 'mobile-chip': $isMobile }"
        :disabled="isSinoaLoading"
        text-color="black"
        @click="$emit('followup-click', question)"
      >
        <span class="chip-text d-block pa-2">
          {{ question }}
        </span>
      </v-chip>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { COLORS } from '@/helpers/colors';

export default {
  name: 'FollowUpQuestionCarousel',

  data() {
    return {
      COLORS,
    };
  },

  computed: {
    ...mapState('chatbot', ['followUpQuestions']),
    ...mapGetters('chatbot', ['isSinoaLoading']),
  },
};
</script>

<style lang="scss" scoped>
.follow-up-chip {
  max-width: 100%;
  height: auto !important;

  .chip-text {
    white-space: normal;
    word-wrap: break-word;
    line-height: 1.2;
  }
}

.mobile-chip {
  width: 100%;
  max-width: 100%;
  min-height: auto !important;

  .chip-text {
    white-space: normal !important;
    word-break: break-word;
  }
}
</style>
